import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from './store';

export type folderStateType = {
  folderId: string;
  folderName?: string;
};

const initialState: folderStateType = {
  folderId: '',
  folderName: ''
};

export const folderStateSlice = createSlice({
  name: 'folderStateSlice',
  initialState,
  reducers: {
    setFolderDetails: (state, action) => {
      state.folderId = action.payload.folderId;
      state.folderName = action.payload.folderName;
    },
    resetFolderDetails: state => {
      state.folderId = '';
      state.folderName = '';
    }
  }
});

export const { setFolderDetails, resetFolderDetails } =
  folderStateSlice.actions;

export const getFolderDetails = (state: RootState) => state.folderStateSlice;
